import { AtividadePlanejamento } from "./AtividadePlanejamento";
import { Cultivar } from "./Cultivar";
import { Etapa } from "./Etapa";
import { ItemEnum } from "./ItemEnum";

export class Planejamento {
    Id: number;
    Descricao:string = "";
    SafraId: number;
    AnoSafraId: number;
    CultivarId: number;
    AreaId: number;
    Padrao: boolean;
    AreaPlantada: number = 0;
    DataPrevistaPlantio: Date = new Date();
    DataRealPlantio: Date = new Date();
    PlanoMestreProducaoId: number;

    QtdAtividades: number = 0;
    QtdEtapas: number = 0;
    CustoPorHA: number = 0;
    ProdutividadeSimulada: number = 0;
    PrecoVendaSimulado: number = 0;
    LucroSimulado: number = 0;
    DataPrevistaColheita: any;
    DescricaoArea:string = "";
    DescricaoSafra:string = "";
    CulturaId: number;
    FlagPlantou: boolean;
    FlagSemente: boolean;
    DescricaoPlanoMestreProducao:string = "";

    Collapse = false;
    AtividadesPlanejamento: AtividadePlanejamento[] = [];
    Etapas: Etapa[] = [];

    Cultivar: Cultivar;
    Status: EnumStatusPlanejmento
    DescricaoStatus: string

    //
    quantidadeAplicacaoPlanejamento: number;
    custoPlanejado: number;
    PulverizacoesPlanejadas: number = 0
    PulverizacoesRealizadas: number = 0
    CustoPlanejado: number = 0
    CustoRealizado: number = 0
    CustoHaPlanejado: number = 0
    CustoHaRealizado: number = 0

    //
    DapPlanoAgronomico: number
}

export class PlanejamentoDetalhe{
PlanejamentoDesc:string = "";
PlanejamentoId: number;
ProcessoDesc:string = "";
ProcessoId: number;
EtapaDesc:string = "";
EtapaId: number;
AtividadeDesc:string = "";
AtividadeId: number;
ProdutoDesc:string = "";
ProdutoId: number;
Dose: number = 0;
}

export enum EnumStatusPlanejmento{
    Configurada = 0,
    EmPlanejamento = 1,
    EmAndamento = 2,
    Colhido = 3,
    NaoConfigurdo = 4,
}
